import { render } from "./HomePage.vue?vue&type=template&id=b503d3e6&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import "./HomePage.vue?vue&type=style&index=0&id=b503d3e6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b503d3e6"

export default script